export default __webpack_public_path__ + "static/media/Phone.a5036cb3.png";